"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unSupportedIsMentionedUserHasPhysician = exports.unSupportedIsMentionedUserHasPatient = void 0;
const unSupportedIsMentionedUserHasPatient = () => {
    throw new Error("Panic: isMentionedUserHasPatient not applicable in this context !!!");
};
exports.unSupportedIsMentionedUserHasPatient = unSupportedIsMentionedUserHasPatient;
const unSupportedIsMentionedUserHasPhysician = () => {
    throw new Error("Panic: message selection not allowed on message item inside started alert tab");
};
exports.unSupportedIsMentionedUserHasPhysician = unSupportedIsMentionedUserHasPhysician;
